module.exports = __webpack_public_path__ + "img/travel_banner_ad.f77ce68d.png";